<template>
  <catalog-tree-panel>
  <template v-slot:title>
  <div class="row">
    <div class="panel-title space">{{ $t('tools.catalogTree.title') }}</div>
    <q-btn
      flat
      dense
      text-color="black"
      icon="layers_clear"
      @click="onToolClick($config.tools.cleanMap)"
    >
      <q-tooltip>
        {{ $t('tools.cleanMap.title') }}
      </q-tooltip>
    </q-btn>
    <q-btn
      flat
      dense
      text-color="black"
      icon="add"
      to="addcustomlayer"
    >
      <q-tooltip>
        {{ $t('tools.addCustomLayer.title') }}
      </q-tooltip>
    </q-btn>
  </div>
  </template>
  </catalog-tree-panel>
</template>

<script>
import { CatalogTreePanel } from '@giscube/geoportal'
import { QBtn, QTooltip } from 'quasar'

export default {
  components: {
    CatalogTreePanel, QBtn, QTooltip
  },
  beforeRouteEnter: CatalogTreePanel.beforeRouteEnter,
  beforeRouteUpdate: CatalogTreePanel.beforeRouteUpdate,
  methods: {
    onToolClick (tool) {
      if (tool.to) {
        this.$router.push({ path: tool.to })
      }
      if (tool.action) {
        tool.action.call(this, tool)
      }
    }
  }
}
</script>
